/* eslint-disable  array-callback-return */
import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { Button, TextField } from "@veriff/genoma";
import "./UploadPage.css";
import UploadStatus from "./UploadStatus/UploadStatus.js";
import FinishPage from "../FinishPage/FinishPage.js";
import ErrorPages from "../ErrorPages/ErrorPages.js";
import ProgressBar from "./ProgressBar/ProgressBar.js";
import Header from "./Header/Header.js";
import {completeUpload, getPostUrl, validatePostUrl, generatePath, upload2S3Post, sleep} from "../api/api.js";

const MiniUploadPage = ({ files, token }) => {
    const [upStatus, setUpStatus] = useState({});
    const [uploadCount, setUploadCount] = useState(0);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [pathError, setPathError] = useState(false);
    const [newNames, setNewNames] = useState({});
    const [renameStatus, setRenameStatus] = useState({});

    useEffect(() => {
        window.Intercom("boot", {
            app_id: "yn2gxy8s",
        });
    }, []);

    useEffect(() => {
        if (files && uploadCount === files.length) {
            completeUpload(token);
            setUploadComplete(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadCount]);

    useEffect(() => {
        if (files && files.length > 0) {
            uploadFiles();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files]);

    async function uploadFiles() {
        let postParams;
        let validator;
        try {
            for (let i = 0; i <= files.length - 1; i += 1) {
                const pathBranchCount = files[i].path.split("/").length - 1;
                if (pathBranchCount <= 2) {
                    setPathError(true);
                }
                postParams = await getPostUrl(files[i].path, token);
                validator = await validatePostUrl(postParams);
                await sleep(300);

                if (validator.isOk) {
                    const respUpload2S3Post = await upload2S3Post(postParams.signed_url, files[i]);
                    if (respUpload2S3Post.ok === true) {
                        setUploadCount((prevState) => prevState + 1);
                    } else {
                        const uploadSts = {
                            status: "error",
                            desc: "Error occured during file upload, please try to reupload this file",
                            code: 3000,
                        };
                        setUpStatus((prevState) => ({ ...prevState, [files[i].path]: uploadSts }));
                    }
                } else {
                    const uploadSts = {
                        status: "error",
                        desc: validator.data,
                        code: validator.code,
                    };
                    setUpStatus((prevState) => ({ ...prevState, [files[i].path]: uploadSts }));
                }
            }
        } catch (err) {}
    }

    const handleRenameClick = (fpath) => {
        const fname = fpath.substr(fpath.lastIndexOf("/") + 1);
        let warning = "Name should include one of (front | back | face | udocs)";
        setNewNames((prevState) => ({ ...prevState, [fpath]: fname }));
        const rename = {
            status: true,
            newName: fname,
            warning: warning,
        };
        setRenameStatus((prevState) => ({ ...prevState, [fpath]: rename }));
    };

    const renameFile = async (fpath, newName) => {
        setNewNames((prevState) => ({ ...prevState, [fpath]: newName }));
        let warning = "";
        const path = await generatePath(fpath, newName);
        if (!(newName.includes("front") || newName.includes("back") || newName.includes("face") || newName.includes("udocs"))) {
            warning = "Name should include one of (front | back | face | udocs)";
        } else if (!(newName.includes(".png") || newName.includes(".jpg") || newName.includes(".jpeg") || newName.includes(".pdf"))) {
            warning = "Please add extension to the file name (png | jpg | jpeg | pdf)";
        } else {
            files.forEach((file) => {
                if (file.path === path) {
                    warning =
                        "This file already exist, please set a unique name. Otherwise existing file will be overwritten";
                }
            });
        }
        const rename = {
            status: true,
            newName: newName,
            newPath: path,
            warning: warning,
        };
        setRenameStatus((prevState) => ({ ...prevState, [fpath]: rename }));
    };

    const reUploadFile = async (fpath) => {
        if (renameStatus[fpath]) {
            const rename = {
                status: false,
            };
            setRenameStatus((prevState) => ({ ...prevState, [fpath]: rename }));
        }

        if (upStatus && upStatus[fpath]) {
            let path;
            files.map(async (file) => {
                if (fpath === file.path) {
                    path = fpath;

                    if (upStatus[fpath].code === 2000 || (newNames && newNames[file.path])) {
                        path = renameStatus[fpath].newPath;
                    }
                    const postParams = await getPostUrl(path, token);
                    const validator = await validatePostUrl(postParams);
                    if (validator.isOk) {
                        const respReUploadS3 = await upload2S3Post(postParams.signed_url, file);
                        if (respReUploadS3.ok === true) {
                            setUploadCount((prevState) => prevState + 1);
                            setUpStatus((prevState) => ({ ...prevState, [file.path]: { status: "ok" } }));
                        } else {
                            const uploadSts = {
                                status: "error",
                                desc: "Error occurred during file upload, please try to reupload this file",
                                code: 3000,
                            };
                            setUpStatus((prevState) => ({ ...prevState, [file.path]: uploadSts }));
                        }
                    } else if (!validator.isOk) {
                        const uploadSts = {
                            status: "error",
                            desc: validator.desc,
                            code: validator.code,
                        };
                        setUpStatus((prevState) => ({ ...prevState, [file.path]: uploadSts }));
                    }
                }
            });
        }
    };

    if (pathError) {
        return <ErrorPages errorCode={7001} />;
    } else if (!uploadComplete) {
        return (
            <div>
                <Header />
                <div className="upload-page-info">
                    <h2 className="upload-page-title">Uploading</h2>
                    <p className="upload-page-desc">
                        Your files are being uploaded. We will let you know when it’s done.<br></br>
                        Since there are so many files to upload, we disabled some UI components for better performance.
                    </p>
                </div>
                <div className="progressContainer">
                    {files && <ProgressBar uploadedCount={uploadCount} fileCount={files.length} />}
                </div>
                {upStatus &&
                    Object.keys(upStatus).map((fpath) => {
                        if (upStatus[fpath].status === "error") {
                            const fname = fpath.substr(fpath.lastIndexOf("/") + 1);
                            return (
                                <Card.Body key={fpath} className="file-card-with-error">
                                    {(fname.includes("face") ||
                                        (newNames && newNames[fpath] && newNames[fpath].includes("face"))) && (
                                        <img alt="face_image" src="/icon-file-green.svg" />
                                    )}
                                    {(fname.includes("front") ||
                                        (newNames && newNames[fpath] && newNames[fpath].includes("front"))) && (
                                        <img alt="front_image" src="/icon-file-yellow.svg" />
                                    )}
                                    {(fname.includes("back") ||
                                        (newNames && newNames[fpath] && newNames[fpath].includes("back"))) && (
                                        <img alt="back_image" src="/icon-file-purple.svg" />
                                    )}
                                    {(fname.includes("udocs") ||
                                        (newNames && newNames[fpath] && newNames[fpath].includes("udocs"))) && (
                                        <img alt="udocs_image" src="/icon-file-yellow.svg" />
                                    )}
                                    {fpath}
                                    {renameStatus && renameStatus[fpath] && renameStatus[fpath].status === true && (
                                        <div className="rename-container">
                                            <TextField
                                                className="text-field"
                                                error={renameStatus[fpath].warning}
                                                caption="Rename the file"
                                                value={newNames[fpath]}
                                                onChange={(e) => renameFile(fpath, e.target.value)}
                                            />
                                            <Button className="reupload-button" onClick={() => reUploadFile(fpath)}>
                                                SAVE
                                            </Button>
                                        </div>
                                    )}

                                    {upStatus &&
                                        upStatus[fpath] &&
                                        upStatus[fpath].code >= 2000 &&
                                        upStatus[fpath].code < 3000 &&
                                        !(
                                            renameStatus &&
                                            renameStatus[fpath] &&
                                            renameStatus[fpath].status === true
                                        ) && (
                                            <img
                                                className="icon-button"
                                                onClick={() => handleRenameClick(fpath)}
                                                alt="edit"
                                                src="/icon-edit.svg"
                                            />
                                        )}
                                    {upStatus && upStatus[fpath] && upStatus[fpath].code >= 3000 && (
                                        <img
                                            className="icon-button"
                                            onClick={() => reUploadFile(fpath)}
                                            alt="repeat"
                                            src="/icon-repeat.svg"
                                        />
                                    )}

                                    <UploadStatus type="lightFile" info={upStatus[fpath].desc} />
                                </Card.Body>
                            );
                        }
                    })}
            </div>
        );
    } else if (uploadComplete) {
        return <FinishPage />;
    }
};

export default MiniUploadPage;
